import { ref, onMounted, onUnmounted } from "vue";

function getDeviceType() {
  const ua = navigator.userAgent;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const aspectRatio = screenWidth / screenHeight;
  if (
    /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
    (screenWidth >= 768 && screenWidth < 1024)
  ) {
    if (aspectRatio < 1) {
      return "tablet-portrait";
    } else {
      return "tablet-landscape";
    }

    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    ) ||
    screenWidth < 768
  ) {
    return "mobile";
  }
  return "desktop";
}

export { getDeviceType };

export default function useDeviceType() {
  const deviceType = ref(getDeviceType());

  const updateDeviceType = () => {
    deviceType.value = getDeviceType();
  };

  onMounted(() => {
    window.addEventListener("resize", updateDeviceType);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateDeviceType);
  });

  return {
    deviceType,
  };
}
